import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-bank",
  "use": "icon-menu-bank-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol viewBox=\"0 0 30 30\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu-bank\"><path d=\"M24,7V6c0-1.105-0.895-2-2-2H3C1.895,4,1,4.895,1,6v1H24z\" /><path d=\"M1,10v9c0,1.105,0.895,2,2,2h19c1.105,0,2-0.895,2-2v-9H1z\" /><path d=\"M29,11v-1c0-1.105-0.895-2-2-2h-1v3H29z\" /><path d=\"M26,14v7c0,1.105-0.895,2-2,2H6v1c0,1.105,0.895,2,2,2h19c1.105,0,2-0.895,2-2V14H26z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu-bank.svg
// module id = T5Hx
// module chunks = 83